/**
 * Whether photos on a Procedure can still be added, retried or removed.
 *
 * Photos are read-only once the Procedure is completed, once its Work Order
 * is completed or canceled, or when the execution is otherwise read-only.
 * This is the single place that rule lives: the product decision on exactly
 * when evidence locks is still open, so change it here only.
 */
export function canChangeProcedurePhotos({
  workOrderStatusCode,
  executionStatus,
  readOnly,
}: {
  workOrderStatusCode: string | undefined;
  executionStatus: "NOT_STARTED" | "IN_PROGRESS" | "COMPLETED" | undefined;
  readOnly: boolean;
}) {
  if (readOnly) return false;
  if (executionStatus === "COMPLETED") return false;
  return (
    workOrderStatusCode !== "COMPLETED" && workOrderStatusCode !== "CANCELED"
  );
}
